<template>
  <div class="new-contents">
    <ul class="nav-tab">
      <template v-if="isGotExtTypeName">
        <li @click="contentKind = 'origin'" :class="{selected: contentKind === 'origin'}" class="origin">過去のメーリング</li>
        <li v-if="isExtTypeNameEcV1" @click="contentKind = 'ec_v1'" :class="{selected: contentKind === 'ec_v1'}" class="ec_v1">EngageCros連携</li>
        <li v-else-if="isExtTypeNameEcV2" @click="contentKind = 'ec_v2'" :class="{selected: contentKind === 'ec_v2'}" class="ec_v2">EngageCros連携</li>
        <li v-else-if="isExtTypeNameMpLite" @click="contentKind = 'mp_lite'" :class="{selected: contentKind === 'mp_lite'}" class="mp_lite">MailPublisher Lite連携</li>
        <li v-else-if="isExtTypeNameMpNext" @click="contentKind = 'mp_next'" :class="{selected: contentKind === 'mp_next'}" class="mp_next">MailPublisher Next連携</li>
        <li v-else @click="contentKind = 'mp'" :class="{selected: contentKind === 'mp'}" class="mp">MailPublisher連携</li>
        <li @click="contentKind = 'hosting'" :class="{selected: contentKind === 'hosting'}" class="hosting">WEB公開</li>
        <li @click="contentKind = 'zip_export'" :class="{selected: contentKind === 'zip_export'}" class="zip-export">エクスポート</li>
        <li class="underline"></li>
      </template>
    </ul>
    <my-contents :kind="contentKind" :extTypeName="extTypeName"/>
  </div>
</template>

<script>
import MyContents from '@/components/Contents/MyContents'
export default {
  components: {
    MyContents
  },
  data () {
    return {
      contentKind: 'origin',
      extTypeName: '',
      isGotExtTypeName: false,
    }
  },
  created () {
    this.getExtTypeName()
  },
  computed: {
    isExtTypeNameEcV1 () {
      return this.extTypeName === 'ec_v1'
    },
    isExtTypeNameEcV2 () {
      return this.extTypeName === 'ec_v2'
    },
    isExtTypeNameMpLite () {
      return this.extTypeName === 'mp_lite'
    },
    isExtTypeNameMpNext () {
      return this.extTypeName === 'mp_next'
    },
  },
  methods: {
    getExtTypeName () {
      this.$http({
        url: `/site`,
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          this.extTypeName = json.data.extTypeName
          this.isGotExtTypeName = true
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.new-contents {
  font-size: 14px;
  position: relative;
  .nav-tab {
    position: relative;
    display: inline-block;
    margin-bottom: 60px;
    text-align: center;
    cursor: pointer;
    user-select:none;
    height: 40px;
    li {
      display: inline-block;
      color: #A7A7A7;
      background: #f8f8f8;
      height: 40px;
      line-height: 40px;
      border-bottom: #dbdbdb 0.5px solid;
      font-size: 18px;
      width: 250px;
      &:nth-of-type(3), &:nth-of-type(4) {
        width: 160px;
      }
      a {
        color: #A7A7A7;
        display: block;
      }
      &.selected, &:hover, a:hover {
        color: $commonFontColor;
      }
      &.selected {
        border: none;
        ~ .underline {
          width: 250px;
          height: 1.5px;
          background: $primaryColor;
          position: absolute;
          bottom: -1.5px;
          transition: all 0.2s ease-in-out 0s;
          border: none;
        }
      }
      &.origin {
        &::before {
          content: '\f0e0';
          font-family: "Font Awesome 5 Free";
          font-weight: 900;
          padding-right: 8px;
          font-size: 20px;
        }
        &.selected {
          ~ .underline {
            left: 0%;
          }
        }
      }
      &.mp.selected, &.ec_v1.selected, &.ec_v2.selected, &.mp_lite.selected, &.mp_next.selected {
        ~ .underline {
          left: 250px;
        }
      }
      &.hosting.selected {
        ~ .underline {
          left: 500px;
          width: 160px;
        }
      }
      &.zip-export.selected {
        ~ .underline {
          left: 660px;
          width: 160px;
        }
      }
    }
  }
}
</style>
